export default {"src":"/_next/static/media/comprehensiveDataProtection.0890e682.svg","height":27,"width":22};